import { render } from "./CustomCategoryMultimediaListAndEditItemView.vue?vue&type=template&id=455f5cde&scoped=true&ts=true"
import script from "./CustomCategoryMultimediaListAndEditItemView.vue?vue&type=script&lang=ts"
export * from "./CustomCategoryMultimediaListAndEditItemView.vue?vue&type=script&lang=ts"

import "./CustomCategoryMultimediaListAndEditItemView.vue?vue&type=style&index=0&id=455f5cde&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455f5cde"]])

export default __exports__